import { Theme, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { UIReplacer, UIReplacerName } from 'src/components/TextWithUI/types';
import { MENTION_CLASS } from './const';

export const mentionChipStyles = (theme: Theme) => ({
  [`& .${MENTION_CLASS}`]: {
    color: theme.palette.custom.OV.sys.mentionText,
    backgroundColor: theme.palette.custom.OV.sys.mentionTextBackground,
    borderRadius: '0.4rem',
    boxDecorationBreak: 'clone',
    padding: '0.1rem 0.3rem',
  },
});

export const useTextWithUIMentions = (): UIReplacer => {
  const theme = useTheme();

  return useMemo(
    () => ({
      name: UIReplacerName.Mention,
      parentStyles: mentionChipStyles(theme),
    }),
    [theme],
  );
};
